// extracted by mini-css-extract-plugin
module.exports = {"StepWithIcon":"StepWithIcon-module__StepWithIcon___266GR","iconsSet":"StepWithIcon-module__iconsSet___2MZ7U"};